export default "<div (click)=\"handleCancelAppointment()\" class=\"pointer-event\">\n    <ng-content #name></ng-content>\n</div>\n"